import React, { useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import AOS from "aos";
import "aos/dist/aos.css";
import GrabButton from "../../../Button/GrabButton";
const useStyles = makeStyles((theme) => ({
  bg: {
    color: "white",
    marginTop: "10rem",
    padding: "5rem",
  },
}));

export default function Food() {
  const classes = useStyles();
  const theme = useTheme();
  useEffect(() => {
    AOS.init({});
  }, []);

  return (
    <Grid container className={classes.bg}>
      <Typography
        variant="h3"
        gutterBottom
        style={{ fontWeight: 300 }}
        data-aos="fade-right"
        data-aos-duration="1000"
      >
        Thức ăn
      </Typography>
      <Typography
        variant="body1"
        paragraph
        data-aos="fade-left"
        data-aos-duration="2000"
      >
        Bún bắp bò là một món ăn dân dã của người Việt và có thể xem đây đại
        diện cho một trong những món ăn tiêu biểu cho nền ẩm thực Việt Nam. Giữa
        các quán bún danh tiếng lâu đời ở bốn phương, người Sài Gòn đặc biệt
        đánh giá bún bắp bò O Như như là món ăn buổi sáng tinh thần. Có thể đánh
        giá, bún bắp bò O Như mang đến giá cả hợp lí, không gian sạch sẽ, và
        mang phong cách thuần Việt trong từng cọng bún.
      </Typography>
      <Grid
        item
        direction="row"
        style={{
          paddingTop: theme.spacing(5),
          display: "flex",
          alignItems: "center",
        }}
      >
        <GrabButton />
        <Typography
          variant="h6"
          style={{
            padding: theme.spacing(2),
            fontWeight: "bold",
          }}
        >
          HOẶC
        </Typography>
        <Typography variant="h5">
          <a
            href="https://www.google.com/maps/place/B%C3%BAn+B%E1%BA%AFp+B%C3%B2+O+Nh%C6%B0/@10.7400125,106.6757078,17z/data=!4m13!1m7!3m6!1s0x31752faceb2a9621:0x54ec2b6171781878!2zMTM0IMSQxrDhu51uZyBDYW8gTOG7lywgUGjGsOG7nW5nIDQsIFF14bqtbiA4LCBUaMOgbmggcGjhu5EgSOG7kyBDaMOtIE1pbmg!3b1!8m2!3d10.7400125!4d106.6778965!3m4!1s0x31752fcbf2b71fef:0xff4b8413fe51f530!8m2!3d10.7400125!4d106.6778965"
            target="_blank"
            rel="noreferrer"
            style={{ color: "white", textTransform: "uppercase" }}
          >
            Ăn tại quán!
          </a>
        </Typography>
      </Grid>
    </Grid>
  );
}
